import type { ImageOperation } from "../ditto/image/IImageMgr";
import type { IImageOp_Crop } from "../ditto/image/IImageOp_Crop";
import type { IImageOp_Flip } from "../ditto/image/IImageOp_Flip";
import { ImageInfo } from "../ditto/image/ImageInfo";
import { Ditto } from "../ditto/Instance";
import { LFW } from "../LFW";
import type { IUIImgInfo } from "./IUIImgInfo.dat";
import { validate_ui_img_info } from "./utils/validate_ui_img_info";

export async function ui_load_img(lfw: LFW, img: IUIImgInfo): Promise<ImageInfo> {
  const errors: string[] = [];
  validate_ui_img_info(img, errors);
  if (errors.length) throw new Error(errors.join('\n'));

  const { path, x, y, w, h, dw, dh, flip_x = 0, flip_y = 0 } = img;
  const p = Ditto.MD5([x, y, w, h, dw, dh, flip_x, flip_y].join())
  const img_key = `${path}?x=${p}`;
  const ops: ImageOperation[] = []
  if (dw || dh) {
    const op: IImageOp_Crop = {
      type: "crop", ...img
    }
    ops.push(op)
  }
  if (flip_x || flip_y) {
    const op: IImageOp_Flip = {
      type: "flip",
      x: flip_x,
      y: flip_y,
    }
    ops.push(op)
  }
  const info = await lfw.images.load_img(img_key, path, ops);
  lfw.images.pin(img_key);
  return info;
}
